import { useParams } from '@tanstack/react-router';
import { ExtractionDetailContainer } from '../../contexts/extractions';

export function ExtractionDetailPage() {
  const { extractionId } = useParams({
    from: '/authenticated/orgs/$orgSlug/extractions/$extractionId/',
  });
  return <ExtractionDetailContainer extractionId={extractionId} />;
}
